interface CosmoBudLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'custom';
  showText?: boolean;
  textLayout?: 'vertical' | 'horizontal';
  customSize?: string;
}

export function CosmoBudLogo({
  size = 'md',
  showText = true,
  textLayout = 'vertical',
  customSize,
}: CosmoBudLogoProps) {
  const sizeClasses = {
    sm: { logo: 'w-8 h-8', text: 'text-xs' },
    md: { logo: 'w-10 h-10', text: 'text-sm' },
    lg: { logo: 'w-12 h-12', text: 'text-base' },
    custom: { logo: customSize || 'w-20 h-20', text: 'text-sm' },
  };

  const classes = sizeClasses[size];

  return (
    <div className={`flex ${textLayout === 'vertical' ? 'flex-col' : 'flex-row'} items-center ${textLayout === 'horizontal' ? 'gap-3' : 'gap-1.5'}`}>
      <img
        src="/cosmobud-logo.png"
        alt="CosmoBud"
        className={`${classes.logo} rounded-lg flex-shrink-0 object-cover`}
      />
      {showText && (
        <div className={textLayout === 'vertical' ? 'text-center' : ''}>
          <div className="font-semibold text-slate-900 dark:text-white text-sm">CosmoBud</div>
          {textLayout === 'vertical' && (
            <div className="text-xs text-muted-foreground">Portal</div>
          )}
        </div>
      )}
    </div>
  );
}
